import script from "./HzPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./HzPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./HzPlayer.vue?vue&type=style&index=0&id=7f8f60e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8f60e5"]])

export default __exports__